import { TRADABLES_TYPE } from "@helpers/constants";
import { Cryptocoin as OldCryptocoin } from "@models/asset/cryptocoins/currencies/cryptocoin";
import { Tradable, TradableAdapter } from "../tradable";

export interface Cryptocoin extends Tradable {
	indexOnly: boolean;
	supportDestinationTag: boolean;
	urlCheckAddress: string;
	urlCheckTransaction: string;
}

export class CryptocoinAdapter extends TradableAdapter {
	public adapt(coin: OldCryptocoin): Cryptocoin {
		const tradable = super.adapt(coin);
		return {
			...tradable,
			indexOnly: coin.isIndexOnly(),
			supportDestinationTag: coin.getSupportsDestinationTag(),
			urlCheckAddress: coin.urlCheckAddress(),
			urlCheckTransaction: coin.urlCheckTransaction(),
			type: TRADABLES_TYPE.CRYPTO
		};
	}
}
